var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 20,
    viewBox: "0 0 41 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.262821,
    y: 0.262821,
    width: 40.4744,
    height: 18.9231,
    rx: 4.99359,
    stroke: "#929292",
    strokeWidth: 0.525641
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8108 15H10.5536V9.54759H9.16123V7.6715H10.5536V5.39966H12.8108V7.6715H14.2032V9.54759H12.8108V15ZM17.4309 15.1905C15.8772 15.1905 14.9099 14.2818 14.9099 12.8454C14.9099 11.497 15.8626 10.6615 17.6214 10.5296L19.6734 10.3684V10.2511C19.6734 9.53294 19.2337 9.15185 18.4275 9.15185C17.4748 9.15185 16.9618 9.51828 16.9618 10.1778H15.0857C15.0857 8.5216 16.4488 7.43699 18.5448 7.43699C20.6701 7.43699 21.8719 8.6242 21.8719 10.7202V15H19.8786L19.732 14.0326C19.4975 14.7069 18.5301 15.1905 17.4309 15.1905ZM18.2223 13.5196C19.0871 13.5196 19.688 13.0946 19.688 12.2591V11.8634L18.5448 11.966C17.5628 12.0539 17.211 12.2738 17.211 12.7428C17.211 13.2705 17.5335 13.5196 18.2223 13.5196ZM25.6161 15H23.4909V3.94862H25.748V8.5216C26.1877 7.86204 27.1551 7.42233 28.2104 7.42233C30.2624 7.42233 31.5669 9.01994 31.5669 11.409C31.5669 13.6809 30.1158 15.1905 28.0345 15.1905C27.0085 15.1905 26.1291 14.7362 25.7334 14.062L25.6161 15ZM25.7627 11.2918C25.7627 12.3911 26.4955 13.1239 27.5508 13.1239C28.6208 13.1239 29.295 12.3764 29.295 11.2918C29.295 10.2072 28.6208 9.45965 27.5508 9.45965C26.4955 9.45965 25.7627 10.1925 25.7627 11.2918Z",
    fill: "#929292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTab);
export default __webpack_public_path__ + "static/media/tab.88401bab6cb5caac9d2ce2cd33ff53b9.svg";
export { ForwardRef as ReactComponent };